import { useLayoutEffect, useRef } from 'react';

// iOS Safari can keep scrolling the visual viewport with overflow:hidden alone.
export default function usePlayerDialog() {
    const backdrop = useRef(null);
    useLayoutEffect(() => {
        const body = document.body;
        const scrollX = window.scrollX;
        const scrollY = window.scrollY;
        const properties = ['position', 'top', 'left', 'width', 'overflow'];
        const previous = properties.map(property => [property, body.style.getPropertyValue(property), body.style.getPropertyPriority(property)]);
        body.style.position = 'fixed';
        body.style.top = `${-scrollY}px`;
        body.style.left = `${-scrollX}px`;
        body.style.width = '100%';
        body.style.overflow = 'hidden';

        const viewport = window.visualViewport;
        const updateViewport = () => {
            const element = backdrop.current;
            if (!element) return;
            element.style.top = `${viewport?.offsetTop || 0}px`;
            element.style.left = `${viewport?.offsetLeft || 0}px`;
            element.style.width = `${viewport?.width || window.innerWidth}px`;
            element.style.height = `${viewport?.height || window.innerHeight}px`;
            element.style.setProperty('--player-viewport-height', `${viewport?.height || window.innerHeight}px`);
        };
        updateViewport();
        viewport?.addEventListener('resize', updateViewport);
        viewport?.addEventListener('scroll', updateViewport);
        window.addEventListener('resize', updateViewport);
        return () => {
            viewport?.removeEventListener('resize', updateViewport);
            viewport?.removeEventListener('scroll', updateViewport);
            window.removeEventListener('resize', updateViewport);
            previous.forEach(([property, value, priority]) => {
                if (value) body.style.setProperty(property, value, priority);
                else body.style.removeProperty(property);
            });
            window.scrollTo({ left: scrollX, top: scrollY, behavior: 'instant' });
        };
    }, []);
    return backdrop;
}
